// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q8GF","col":"styles_col__3XQ9Y"};